// Native radio groups handle selection without JS; this only adds address copying.
export async function copyVisitAddress(clipboard, address) {
  if (!clipboard?.writeText) return false;
  try { await clipboard.writeText(address); return true; } catch { return false; }
}
class MabeVisit extends (globalThis.HTMLElement ?? class {}) {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const {signal} = this.controller;
    const button = this.querySelector('[data-copy-address]');
    const status = this.querySelector('[data-copy-status]');
    if (button && globalThis.navigator?.clipboard?.writeText) {
      button.hidden = false;
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        button.disabled = true;
        const address = this.querySelector('[data-visit-address]').innerText.trim();
        const copied = await copyVisitAddress(navigator.clipboard, address);
        if (!signal.aborted) { status.textContent = copied ? button.dataset.success : button.dataset.failure; button.disabled = false; }
      }, {signal});
    }
    document.addEventListener('shopify:block:select', event => {
      if (!this.contains(event.target)) return;
      const panel = event.target.closest('[data-visit-panel]');
      const input = panel && [...this.querySelectorAll('input[type=radio]')].find(input => input.value === panel.dataset.visitPanel);
      if (input) input.checked = true;
    }, {signal});
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}
if (globalThis.customElements && !customElements.get('mabe-visit')) customElements.define('mabe-visit', MabeVisit);
